import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class SalesPersonService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  getSalesPersonDetails(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSalesPerson/GetSalesPersonDetails`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  saveSalesPersonDetails(SalesPersonDetail: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/POSSalesPerson/SaveSalesPersonDetails`,
      SalesPersonDetail,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  deleteSalesPerson(id: number): Observable<any> {
    return this.http.delete(`${this.baseURL}/POSSalesPerson/DeleteSalesPerson/${id}`,
      {
        observe: 'response'
      }).pipe(
        map((res: HttpResponse<any>) => res.body),
        catchError(this.handleError)
      );
  }

  getSalesPersonBySalesmanId(salesmanId: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSalesPerson/GetSalesPersonBySalesmanId/${salesmanId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  saveSalesPersonPhoto(data: any): Observable<any> {
    return this.http.post<any>(
        `${this.baseURL}/POSSalesPerson/SaveSalesPersonPhoto`,
        data,
        { observe: 'response' }
    ).pipe(
        map((res: HttpResponse<any>) => res.body),
        catchError(this.handleError)
    );
}

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}